import * as Sentry from "@sentry/react";
const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.MODE; // development | production | staging (custom)

const enabled = import.meta.env.PROD && Boolean(dsn);
console.log("Sentry enabled:", enabled);

Sentry.init({
  dsn,
  environment,
  enabled,

  // Error Monitoring options
  sendDefaultPii: true,
});
